import { Breadcrumb } from "@core/models/breadcrumb/breadcrumb.model";

export class AppendBrandAction {
    static readonly type = '[Breadcrumb] Append Brand Breadcrumb';

    constructor(public payload: { brand: string, url: string }) { }
}

export class AppendProductNameAction {
    static readonly type = '[Breadcrumb] Append Product Name Breadcrumb';

    constructor(public payload: { productName: string, id: string }) { }
}

export class SetBreadcrumbAction {
    static readonly type = '[Breadcrumb] Set Breadcrumb';

    constructor(public payload: { breadcrumbs: Breadcrumb[] }) { }
}

export class ResetBrandAction {
    static readonly type = '[Breadcrumb] Reset Brand Action';
}
